export default "__VITE_ASSET__B74ts74u__"